import axiosInstance from "../../utils/axiosInstance";

const getHoleOutRule = async () => {
  const response = await axiosInstance.get(
    `hole-out-rule`
  );
  return response.data.data;
};

const updateHoleOutRule = async (params) => {
  const response = await axiosInstance.post(`hole-out-rule`, params);
  return response.data.data;
};

const holeOutRuleService = {
  getHoleOutRule,
  updateHoleOutRule,
};

export default holeOutRuleService;
